import * as typography from './typography';
export default typography;
//# sourceMappingURL=index.js.map